import {Component, Input, OnInit} from '@angular/core';
import {FormStrategy} from "../../../../../interface/form-strategy";
import {LegalCase} from "../../../../../model/legal-case.model";
import {AbstractControl, FormBuilder, FormGroup, Validators} from "@angular/forms";

@Component({
  selector: 'app-legal-case-parcel-strategy',
  templateUrl: './legal-case-parcel-strategy.component.html',
  styleUrls: ['./legal-case-parcel-strategy.component.scss']
})
export class LegalCaseParcelStrategyComponent  implements OnInit, FormStrategy  {
  @Input() legalCaseInput!: LegalCase;
  @Input() type!: AbstractControl<any, any>;
  parcelForm: FormGroup;

  constructor(private formBuilder: FormBuilder) {
    this.createForm();
  }

  private createForm() {
    this.parcelForm = this.formBuilder.group({
      type: [null, Validators.required],
      legalCaseId: [null, Validators.required],
      attachment: [null, Validators.required]
    });
  }

  ngOnInit(): void {
    const legalCaseId = this.legalCaseInput?.id ?? null;
    this.parcelForm.patchValue({type: this.type, legalCaseId: legalCaseId})
  }

  getForm(): FormGroup<any> {
    return this.parcelForm;
  }
}
